import { z } from 'zod'
import type {HttpClient} from "@jantm/model-core";
import {createOfferApi} from "@/api/wiser/offer.ts";
import {defineModel} from '@jantm/model-core'
import OfferFullListItem from "@/templates/Wiser/OfferFullListItem.vue";
import OfferFullDetail from "@/templates/Wiser/OfferFullDetail.vue";
import {
  optionalDateSchema,
  optionalDateTimeSchema,
  optionalNumberOrStringSchema,
  optionalNumberSchema,
  optionalStringSchema
} from "@/types/global.ts";
import {offerStates} from "@/stores/offer";

export const offerSchema = z.object({
  id: z.int(),
  "title": optionalStringSchema,
  "printofferte": optionalStringSchema,
  "naam": optionalStringSchema,
  "contactpersoon": optionalNumberOrStringSchema,
  "adres": optionalStringSchema,
  "adresregel2": optionalStringSchema,
  "postcode": optionalStringSchema,
  "plaats": optionalStringSchema,
  "land": optionalStringSchema,
  "telefoonnummer": optionalStringSchema,
  "offertedatum": optionalDateSchema,
  "referentie": optionalStringSchema,
  "bevestigdop": optionalDateTimeSchema,
  "offertestatus": optionalNumberOrStringSchema.pipe(z.transform((value) => {
    if (
      value !== null &&
      value !== undefined &&
      Object.prototype.hasOwnProperty.call(
        offerStates.value,
        String(value),
      )
    ) {
      return offerStates.value[value]
    }

    return value
  })),
  "opvolgdatum": optionalDateTimeSchema,
  "vervaldatum": optionalDateTimeSchema,
  "korteomschrijving": optionalStringSchema,
  "langeomschrijving": optionalStringSchema,
  "langeomschrijving2": optionalStringSchema,
  "offerteregelonderofferte": z.array(optionalNumberSchema).nullish().optional(),
  "inverse-offerteonderrelatie": optionalNumberSchema,
  "added_on": optionalDateTimeSchema,
  "changed_on": optionalDateTimeSchema,
})

export type Offer = z.infer<typeof offerSchema>

export const offerCollectionSchema = z.array(offerSchema)

export type OfferCollection = z.infer<typeof offerCollectionSchema>

export const offerFilterSchema = z.object({
  fields: z.array(offerSchema.keyof()).nullish().optional(),
  page: optionalStringSchema.default('1'),
  perPage: optionalStringSchema.default('25'),
  filters: optionalStringSchema,
})
export type OfferFilter = z.infer<typeof offerFilterSchema>

export type OfferFilters = {
  id?: string
  offertestatus?: string
  offertedatum?: string
}

export interface CreateOfferModelOptions {
  client: HttpClient
  /** Override when this model does not live at `/api/offers`. */
  endpoint?: string
}

export function createOfferModel(options: CreateOfferModelOptions) {
  return defineModel({
    name: 'Offer',
    schema: offerSchema,
    collectionSchema: offerCollectionSchema,
    filterSchema: offerFilterSchema,
    api: createOfferApi(options.client, options.endpoint),
    identify: (offer: Offer) => String(offer.id),
    templates: { FullListItem: OfferFullListItem, FullDetail: OfferFullDetail },
    // toItems: (collection) => Object.entries(collection.items).map(([, v]) => v),
    // toTotal: (collection => collection.metadata?.total)
  })
}

export type OfferModel = ReturnType<typeof createOfferModel>

declare module '@jantm/model-core' {
  interface ModelRegistry {
    Offer: OfferModel
  }
}
